import { useState } from 'react';
import styled from 'styled-components';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import defaultCities from '/assets/img/CitiesImages/defaultCity.png';
import activeHongKong from '/assets/img/CitiesImages/hongKongCity.png';
import activeMoscow from '/assets/img/CitiesImages/moscowCity.png';
import activeShenzhen from '/assets/img/CitiesImages/shenzhenCity.png';
import { useIsMobile } from '../../hooks/useIsMobile';
import { Text24Medium, Text64Medium } from '../../mixins/mixins';

const CitiesComponent = styled.div`
  position: relative;
  display: flex;
  overflow: hidden;
`;

const PlacesImg = styled.img`
  width: 100%;
`;

const OverlayContainer = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  @media (max-width: 669px) {
    position: relative;
  }
`;

const OverlayItemWrapper = styled.div<{ isMobile?: boolean }>`
  position: relative;
  width: ${props => (props.isMobile ? '100%' : '33.3333%')};
  overflow: hidden;
  height: ${props => (props.isMobile ? '640px' : '100%')};
`;

const OverlayItemMoscow = styled.div<{
  activeCity: string;
  isMobile?: boolean;
}>`
  width: 100%;
  height: ${props =>
          props.activeCity === 'Moscow' || props.isMobile ? '100%' : 0};
  position: relative;
  overflow: hidden;
  transition: height 0.8s ease-out;
`;

const OverlayItemHongKong = styled.div<{
  activeCity: string;
  isMobile?: boolean;
}>`
  width: 100%;
  height: ${props =>
          props.activeCity === 'Hong Kong' || props.isMobile ? '100%' : 0};
  position: relative;
  overflow: hidden;
  transition: height 0.8s ease-out;
`;

const OverlayItemShenzhen = styled.div<{
  activeCity: string;
  isMobile?: boolean;
}>`
  width: 100%;
  height: ${props =>
          props.activeCity === 'Shenzhen' || props.isMobile ? '100%' : 0};
  position: relative;
  overflow: hidden;
  transition: height 0.8s ease-out;
`;

const ActiveCityMoscow = styled.img`
  position: absolute;
  top: 0;
  width: 100%;
`;

const ActiveCityHongKong = styled.img`
  position: absolute;
  top: 0;
  width: 100%;
`;

const ActiveCityShenzhen = styled.img`
  position: absolute;
  top: 0;
  width: 100%;
`;

const HeaderCityMoscow = styled.div<{ activeCity: string; isMobile?: boolean }>`
  position: absolute;
  top: ${props => (props.activeCity === 'Moscow' ? '122px' : '-200px')};
  left: 50%;
  transition: top 0.8s ease-out;
  display: flex;
  flex-direction: column;
  z-index: 99;
  transform: translate(-50%, -50%);
  @media (max-width: 1024px) {
    top: ${props =>
            props.activeCity === 'Moscow' || props.isMobile ? '122px' : '-200px'};
  }
`;

const HeaderCityHonKong = styled.div<{
  activeCity: string;
  isMobile?: boolean;
}>`
  position: absolute;
  bottom: ${props => (props.activeCity === 'Hong Kong' ? '50px' : '-250px')};
  left: 50%;
  transition: bottom 0.8s ease-out;
  display: flex;
  flex-direction: column;
  z-index: 99;
  transform: translate(-50%, -50%);
  @media (max-width: 1024px) {
    bottom: ${props =>
            props.activeCity === 'Hong Kong' || props.isMobile ? '-5px' : '-250px'};
  }
`;

const HeaderCityShenzhen = styled.div<{
  activeCity: string;
  isMobile?: boolean;
}>`
  position: absolute;
  top: ${props => (props.activeCity === 'Shenzhen' ? '126px' : '-200px')};
  left: 50%;
  transition: top 0.8s ease-out;
  display: flex;
  flex-direction: column;
  z-index: 99;
  transform: translateX(-50%);
  @media (max-width: 1024px) {
    top: ${props =>
            props.activeCity === 'Shenzhen' || props.isMobile ? '60px' : '-200px'};
    left: 50%;
  }
`;

const CountryFlag = styled.div`
  display: flex;
  justify-content: center;
  color: rgba(88, 255, 126, 1);
  ${Text24Medium};
`;

const LabelCity = styled.div`
  color: rgba(88, 255, 126, 1);
  ${Text64Medium};
  font-weight: 700;
  text-align: center;
`;

const Cities = () => {
  const [activeCity, setActiveCity] = useState('Moscow');
  const isMobile = useIsMobile();
  return (
    <CitiesComponent id="cities">
      {!isMobile && <PlacesImg src={defaultCities} />}
      <OverlayContainer>
        {!isMobile && (
          <>
            <OverlayItemWrapper onMouseEnter={() => setActiveCity('Moscow')}>
              <HeaderCityMoscow activeCity={activeCity}>
                <CountryFlag>🇷🇺 &nbsp;ru</CountryFlag>
                <LabelCity>MOSCOW</LabelCity>
              </HeaderCityMoscow>
              <OverlayItemMoscow activeCity={activeCity}>
                <ActiveCityMoscow src={activeMoscow} />
              </OverlayItemMoscow>
            </OverlayItemWrapper>
            <OverlayItemWrapper onMouseEnter={() => setActiveCity('Hong Kong')}>
              <HeaderCityHonKong activeCity={activeCity}>
                <LabelCity>HONG KONG</LabelCity>
                <CountryFlag>🇨🇳 &nbsp;ch</CountryFlag>
              </HeaderCityHonKong>
              <OverlayItemHongKong activeCity={activeCity}>
                <ActiveCityHongKong src={activeHongKong} />
              </OverlayItemHongKong>
            </OverlayItemWrapper>
            <OverlayItemWrapper onMouseEnter={() => setActiveCity('Shenzhen')}>
              <HeaderCityShenzhen activeCity={activeCity}>
                <CountryFlag>🇨🇳 &nbsp;ch</CountryFlag>
                <LabelCity>SHENZHEN</LabelCity>
              </HeaderCityShenzhen>
              <OverlayItemShenzhen activeCity={activeCity}>
                <ActiveCityShenzhen src={activeShenzhen} />
              </OverlayItemShenzhen>
            </OverlayItemWrapper>
          </>
        )}
        {isMobile && (
          <Swiper
            spaceBetween={0}
            loop={true}
            navigation={true}
            modules={[Navigation]}
            className={'swiper-cities'}
          >
            <SwiperSlide>
              <OverlayItemWrapper
                onMouseEnter={() => setActiveCity('Moscow')}
                isMobile={isMobile}
              >
                <HeaderCityMoscow activeCity={activeCity} isMobile={isMobile}>
                  <CountryFlag>🇷🇺 &nbsp;ru</CountryFlag>
                  <LabelCity>MOSCOW</LabelCity>
                </HeaderCityMoscow>
                <OverlayItemMoscow activeCity={activeCity} isMobile={isMobile}>
                  <ActiveCityMoscow src={activeMoscow} />
                </OverlayItemMoscow>
              </OverlayItemWrapper>
            </SwiperSlide>
            <SwiperSlide>
              <OverlayItemWrapper
                onMouseEnter={() => setActiveCity('Hong Kong')}
                isMobile={isMobile}
              >
                <HeaderCityHonKong activeCity={activeCity} isMobile={isMobile}>
                  <LabelCity>HONG KONG</LabelCity>
                  <CountryFlag>🇨🇳 &nbsp;ch</CountryFlag>
                </HeaderCityHonKong>
                <OverlayItemHongKong
                  activeCity={activeCity}
                  isMobile={isMobile}
                >
                  <ActiveCityHongKong src={activeHongKong} />
                </OverlayItemHongKong>
              </OverlayItemWrapper>
            </SwiperSlide>
            <SwiperSlide>
              <OverlayItemWrapper
                onMouseEnter={() => setActiveCity('Shenzhen')}
                isMobile={isMobile}
              >
                <HeaderCityShenzhen activeCity={activeCity} isMobile={isMobile}>
                  <CountryFlag>🇨🇳 &nbsp;ch</CountryFlag>
                  <LabelCity>SHENZHEN</LabelCity>
                </HeaderCityShenzhen>
                <OverlayItemShenzhen
                  activeCity={activeCity}
                  isMobile={isMobile}
                >
                  <ActiveCityShenzhen src={activeShenzhen} />
                </OverlayItemShenzhen>
              </OverlayItemWrapper>
            </SwiperSlide>
          </Swiper>
        )}
      </OverlayContainer>
    </CitiesComponent>
  );
};

export default Cities;
